import { Component, Vue, Prop } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { loadLanguageAsync } from '@/i18n';

@Component<ProductSlider>({
  components: {
    PageHeader,
  },
})
export default class ProductSlider extends Vue {
  @Prop({ default: null })
  protected product: any;

  protected currentIndex: number = 0;
  protected imageDialog: boolean = false;

  protected closeImageDialog() {
    if (this.imageDialog) {
      this.imageDialog = false;
    }
  }

  protected changeImageIndex(index: number) {
    this.currentIndex = index;
  }

  protected openImageDialog(product: object) {
    this.imageDialog = true;
  }

  protected previousOrNextImage(imageArrayLength: number, add: boolean) {
    let newIndex = 0;
    if (add) {
      newIndex = this.currentIndex + 1;
      if (newIndex >= imageArrayLength) {
        this.currentIndex = 0;
        return;
      }
    } else {
      newIndex = this.currentIndex - 1;
      if (newIndex === -1) {
        this.currentIndex = imageArrayLength - 1;
        return;
      }
    }
    this.currentIndex = newIndex;
  }
}
